import { lazy } from "react";

export const TERMINAL_OPEN_STORAGE_KEY = "ano-terminal-open";

export const loadCommandPalette = () => import("@/components/CommandPalette");
export const CommandPalette = lazy(() =>
  loadCommandPalette().then((m) => ({
    default: m.CommandPalette,
  })),
);

export const InviteLoginPage = lazy(() =>
  import("@/components/auth/InviteLoginPage").then((m) => ({
    default: m.InviteLoginPage,
  })),
);

export const loadTerminalPanel = () =>
  import("@/components/terminal/TerminalPanel");
export const TerminalPanel = lazy(() =>
  loadTerminalPanel().then((m) => ({
    default: m.TerminalPanel,
  })),
);

export const loadInboxView = () => import("@/components/layout/InboxView");
export const InboxView = lazy(() =>
  loadInboxView().then((m) => ({
    default: m.InboxView,
  })),
);

export const loadListView = () => import("@/components/lists/ListView");
export const ListView = lazy(() =>
  loadListView().then((m) => ({
    default: m.ListView,
  })),
);

export const loadListsOverview = () =>
  import("@/components/lists/ListsOverview");
export const ListsOverview = lazy(() =>
  loadListsOverview().then((m) => ({
    default: m.ListsOverview,
  })),
);

export const loadLibraryView = () => import("@/components/library/LibraryView");
export const LibraryView = lazy(() =>
  loadLibraryView().then((m) => ({
    default: m.LibraryView,
  })),
);

export const loadTeamView = () => import("@/components/team/TeamView");
export const TeamView = lazy(() =>
  loadTeamView().then((m) => ({
    default: m.TeamView,
  })),
);

export const loadInvitesView = () => import("@/components/invites/InvitesView");
export const InvitesView = lazy(() =>
  loadInvitesView().then((m) => ({
    default: m.InvitesView,
  })),
);

export const loadAutomationsPage = () =>
  import("@/pages/automations/AutomationsPage");
export const AutomationsPage = lazy(() =>
  loadAutomationsPage().then((m) => ({
    default: m.AutomationsPage,
  })),
);

export const loadSkillsPage = () => import("@/pages/skills/SkillsPage");
export const SkillsPage = lazy(() =>
  loadSkillsPage().then((m) => ({
    default: m.SkillsPage,
  })),
);

export const loadConnectedToolsPage = () =>
  import("@/pages/connected-tools/ConnectedToolsPage");
export const ConnectedToolsPage = lazy(() =>
  loadConnectedToolsPage().then((m) => ({
    default: m.ConnectedToolsPage,
  })),
);

export const ListItemCreateDialog = lazy(() =>
  import("@/components/lists/ListItemCreateDialog").then((m) => ({
    default: m.ListItemCreateDialog,
  })),
);

export const ListCreateDialog = lazy(() =>
  import("@/components/lists/ListCreateDialog").then((m) => ({
    default: m.ListCreateDialog,
  })),
);

export const KeyboardShortcutsDialog = lazy(() =>
  import("@/components/dialogs/KeyboardShortcutsDialog").then((m) => ({
    default: m.KeyboardShortcutsDialog,
  })),
);

export const GuestMode = lazy(() =>
  import("@/components/guest/GuestMode").then((m) => ({
    default: m.GuestMode,
  })),
);

// First-run wizard — loaded behind the boot cover (Suspense fallback is the
// same `AuthLoadingFullscreen`), so a new user never sees a flash while the
// chunk loads. The gate decision lives in `use-first-run-gate.ts`.
export const loadFirstRunWizard = () =>
  import("@/components/onboarding/FirstRunWizard");
export const FirstRunWizard = lazy(() =>
  loadFirstRunWizard().then((m) => ({
    default: m.FirstRunWizard,
  })),
);

export const UpdateRequiredDialog = lazy(() =>
  import("@/components/UpdateRequiredDialog").then((m) => ({
    default: m.UpdateRequiredDialog,
  })),
);

// Eagerly preload terminal chunk if it was open last session
// so it's ready before Suspense kicks in (eliminates flash on reload)
try {
  if (localStorage.getItem(TERMINAL_OPEN_STORAGE_KEY) === "1") {
    loadTerminalPanel();
  }
} catch {
  // localStorage unavailable
}
